import { Spinner } from "@jobber/components/Spinner";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { jobberAuthorize } from "services";

const JobberCallback = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const navigate = useNavigate();

    useEffect(() => {
        if (!code) {
            navigate("/error", { replace: true });
        }

        (async () => {
            try {
                const res = await jobberAuthorize(code);
                sessionStorage.setItem('state', res.state);
                navigate("/jobber-homedepot-step1", { replace: true });
            } catch(e: any) {
                navigate("/error", { replace: true });
            }
        })();
    }, []);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
            }}
        >
            <Spinner />
            <h1>Jobber authentication in progress</h1>
        </div>
    );
};

export default JobberCallback;
